import * as types from "../actions/types/openApi.types";

const initialState = {
    message: "",
    status: false,
    goLiveData: {},
    clientDetails: {},
    updateLiveData: {},
    goLiveState: "idle",
    clientState: "loading",
    updateClientState: "idle",
    updateLiveState: "idle",
    goLiveMessage: "",
    updateClientMessage: "",
    updateLiveMessage: "",
    limitState: "loading",
    limitMessage: "",
    limitData: {},
    profileState: "idle",
    profileData: null,
};

export const openApiReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.ONBOARD_OPENAPI_FAILED:
            return {
                ...state,
                status: action.status,
                message: action.message,
            };
        case types.ONBOARD_OPENAPI_SUCCESS:
            return {
                ...state,
                status: action.status,
                message: action.message,
            };
        case types.OPENAPI_PROFILE_INPROGRESS:
            return {
                ...state,
                profileState: "loading",
            };
        case types.OPENAPI_PROFILE_FAILED:
            return {
                ...state,
                profileState: "failed",
            };
        case types.OPENAPI_PROFILE_SUCCESS:
            return {
                ...state,
                profileState: "success",
                profileData: action.data,
            };
        case types.GO_LIVE_REQUEST_FAILURE:
            return {
                ...state,
                goLiveMessage: action.message,
                goLiveState: "failed",
            };
        case types.GO_LIVE_REQUEST_SUCCESS:
            return {
                ...state,
                goLiveData: action.data,
                goLiveMessage: action.message,
                goLiveState: "success",
            };
        case types.GET_CLIENT_DETAILS_INPROGRESS:
            return {
                ...state,
                clientState: "loading",
            };
        case types.GET_CLIENT_DETAILS_FAILURE:
            return {
                ...state,
                clientState: "failed",
            };
        case types.GET_CLIENT_DETAILS_SUCCESS:
            return {
                ...state,
                clientState: "success",
                clientDetails: action.data,
            };
        case types.UPDATE_CLIENT_DATA_INPROGESS:
            return {
                ...state,
                updateClientState: "loading",
            };
        case types.UPDATE_CLIENT_DATA_FAILURE:
            return {
                ...state,
                updateClientState: "failed",
            };
        case types.UPDATE_CLIENT_DATA_SUCCESS:
            return {
                ...state,
                updateClientState: "success",
                updateClientMessage: action.message,
            };
        case types.UPDATE_LIVE_INPROGRESS:
            return {
                ...state,
                updateLiveState: "loading",
            };
        case types.UPDATE_LIVE_FAILURE:
            return {
                ...state,
                updateLiveState: "failed",
                updateLiveMessage: action.message,
            };
        case types.UPDATE_LIVE_SUCCESS:
            return {
                ...state,
                clientDetails: action.data,
                updateLiveMessage: action.message,
                updateLiveState: "success",
            };
        case types.GET_VIRTUAL_ACCOUNT_LIMIT_INPROGRESS:
            return {
                ...state,
                limitState: "loading",
            };
        case types.GET_VIRTUAL_ACCOUNT_LIMIT_FAILURE:
            return {
                ...state,
                limitState: "failed",
                limitMessage: action.message,
            };
        case types.GET_VIRTUAL_ACCOUNT_LIMIT_SUCCESS:
            return {
                ...state,
                limitState: "success",
                limitMessage: action.message,
                limitData: action.data,
            };

        default:
            return state;
    }
};
